module.exports = __webpack_public_path__ + "img/video-17.794e1189.png";